export default __webpack_public_path__ + "alberta-signature.3c931a6e56c08f70629a.svg";